import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Toggle from 'material-ui/Toggle';
import { Box, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';
import Dialog from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import debounce from 'lodash.debounce';
import { refSetter } from '../../../utils/helpers';
import Table from '../../../containers/common/tables/tableContainer';
import { referralServicesEndPoint } from '../../../settings/constants';
import { toggleGrey, textFieldStyle } from '../../../theme/AllocateBaseTheme';
import globals from '../../../globals/communityGlobals';
import DefaultPageWrapper from '../../../containers/PageStructure/DefaultPageWrapper/DefaultPageWrapperContainer';
import AddEditServiceForm from './AddEditServiceForm';
import AlertBox from '../../../components/common/AlertBox/AlertBox';

export const actionTypes = {
  create: 'CREATE',
  edit: 'EDIT',
};
const locale = globals.getAreas(['referralServices', 'error', 'pageTitles']);
const maxNameLength = 50;

class ReferralServicesForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      reloadData: false,
      referralDetails: null,
      searchRefService: '',
      callbackModel: {
        funcName: '',
        funcParams: null,
      },
      openDialog: false,
    };

    this.setRef = refSetter.bind(this);
  }

  componentWillUnmount() {
    this.props.dismissError();
  }

  onChangeDebounced = debounce(value => {
    this.setState({
      callbackModel: {
        funcName: 'updateParamsAndGetData',
        funcParams: {
          referralServiceNameOrID: value,
        },
      },
    });
  }, 500);

  updateReferral = (referralModel, callback) => this.props.updateReferralService(referralModel).then(callback);

  handleUpdateStatus = row => (event, isInputChecked) => {
    const referralModel = {
      id: row.id,
      name: row.name,
      isActive: isInputChecked,
      serviceId: row.serviceId,
      gradeUpgradeAllowed: row.gradeUpgradeAllowed,
      endDate: globals.now.subtract(1, 'd').toDate(),
    };
    const callback = () => {
      this.setState({ reloadData: !this.state.reloadData });
      if (this.state.referralDetails && this.state.referralDetails.id === row.id) {
        this.setState({
          referralDetails: {
            ...this.state.referralDetails,
            isActive: isInputChecked,
          },
        });
      }
    };

    this.updateReferral(referralModel, callback);
  };

  handleUpdateGradeUpgradeAllowed = row => (event, isInputChecked) => {
    const referralModel = {
      id: row.id,
      name: row.name,
      isActive: row.isActive,
      serviceId: row.serviceId,
      gradeUpgradeAllowed: isInputChecked,
      endDate: moment(row.endDate).format(globals.dateFormats.date),
    };
    const callback = () => {
      this.setState({ reloadData: !this.state.reloadData });

      if (this.state.referralDetails && this.state.referralDetails.id === row.id) {
        this.setState({
          referralDetails: {
            ...this.state.referralDetails,
            gradeUpgradeAllowed: isInputChecked,
          },
        });
      }
    };

    this.updateReferral(referralModel, callback);
  };

  updateReferralServiceNameValue = (event, value) => {
    const stateUpdate = { errorMessage: '' };
    if (value.length > maxNameLength) {
      stateUpdate.errorMessage = locale.getMsg('validationMaxLength', [maxNameLength.toString()]);
    } else {
      stateUpdate.referralServiceName = value;
    }
    this.setState(stateUpdate);
  };

  handleClick = rowInfo => {
    this.setState({
      referralDetails: {
        ...this.state.referralDetails,
        ...rowInfo.original,
      },
    });
  };

  handleAdd = data => {
    return this.props
      .createReferralService({
        ...data,
      })
      .then(() => this.setState({ reloadData: !this.state.reloadData }));
  };

  handleEdit = (data, id, isActive, gradeUpgradeAllowed) => {
    this.props
      .validateReferralService({
        ...data,
      })
      .then(response => {
        if (response.response.data.hasFutureAssignedTreatmentInstances) {
          this.setState({ openDialog: true });
        } else {
          this.props
            .updateReferralService({
              ...data,
              id,
              isActive,
              gradeUpgradeAllowed,
            })
            .then(() => this.setState({ referralDetails: null, reloadData: !this.state.reloadData }));
        }
      });
  };

  handleSearchInput = (event, value) => {
    this.setState({
      searchRefService: value,
    });

    this.onChangeDebounced(value);
  };

  handleSearchInput = (event, value) => {
    this.setState({
      searchRefService: value,
    });

    this.onChangeDebounced(value);
  };

  handleDialogClose = () => {
    this.setState({ openDialog: false });
  };

  render() {
    const columns = [
      {
        Header: locale.getMsg('name'),
        accessor: 'name',
      },
      {
        Header: locale.getMsg('serviceId'),
        accessor: 'serviceId',
      },
      {
        Header: locale.getMsg('status'),
        id: 'isActive',
        accessor: row => (
          <div className="col-c4 formsytext-css">
            <span>
              <Toggle
                id={row.id}
                defaultToggled={row.isActive}
                onToggle={this.handleUpdateStatus(row)}
                thumbStyle={toggleGrey.thumbStyle}
                trackStyle={toggleGrey.trackStyle}
                disabled={!row.isActive}
              />
            </span>
          </div>
        ),
      },
      {
        Header: locale.getMsg('gradeUpgradeAllowed'),
        id: 'gradeUpgradeAllowed',
        accessor: row => (
          <div className="col-c4 formsytext-css">
            <span>
              <Toggle
                id={`${row.id}_grade`}
                defaultToggled={row.gradeUpgradeAllowed}
                onToggle={this.handleUpdateGradeUpgradeAllowed(row)}
                thumbStyle={toggleGrey.thumbStyle}
                trackStyle={toggleGrey.trackStyle}
                disabled={!row.isActive}
              />
            </span>
          </div>
        ),
      },
      {
        Header: 'End Date',
        id: 'endDate',
        accessor: row => (
          <div className="col-c4 formsytext-css">
            <span>{moment(row.endDate).format(globals.dateFormats.date)}</span>
          </div>
        ),
      },
    ];

    const { failureMessage, dismissError } = this.props;
    const { referralDetails, searchRefService, openDialog } = this.state;
    return (
      <DefaultPageWrapper pageTitle={locale.getMsg('referralServices')}>
        <Dialog
          title="Warning"
          modal
          open={openDialog}
          onClose={this.handleDialogClose}
          aria-labelledby="customized-dialog-title"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              All scheduled visits need to be cancelled before you can set the service end date. Please proceed to
              assign another Referral Service.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleDialogClose} color="primary">
              OK
            </Button>
          </DialogActions>
        </Dialog>
        <div className="services-referral-wrapper">
          <Box className="filter-section" display="flex" flexDirection="column" px={2} py={1}>
            <AlertBox
              type="notification"
              innerRef={this.setRef('alertBox')}
              content={failureMessage}
              onClick={dismissError}
            />
            <TextField
              floatingLabelStyle={textFieldStyle.floatingLabelStyle}
              floatingLabelShrinkStyle={textFieldStyle.floatingLabelShrinkStyle}
              style={textFieldStyle.style}
              inputStyle={textFieldStyle.inputStyle}
              underlineStyle={textFieldStyle.underlineStyle}
              underlineFocusStyle={textFieldStyle.underlineFocusStyle}
              floatingLabelText={locale.getMsg('searchReferralServicesInputLabelText')}
              value={searchRefService}
              onChange={this.handleSearchInput}
            />
          </Box>
          <Box display="flex" p={1}>
            <Box p={1} style={{ width: '70%' }}>
              <div style={{ borderRight: '1px solid #3681b3', paddingRight: '8px' }}>
                <Table
                  triggerReload={this.state.reloadData}
                  reloadCallback={this.state.callbackModel}
                  afterReloadCallback={() => this.setState({ callbackModel: { funcName: '', funcParams: null } })}
                  columns={columns}
                  endpoint={referralServicesEndPoint}
                  responseObjectName="options"
                  reduxIdentifier="referralServices"
                  rowOnClick={this.handleClick}
                  initialSearchParams={{
                    pageNumber: 1,
                    pageSize: 5,
                    referralServiceNameOrID: null,
                    sortColumn: 'Name',
                    sortDirection: 'asc',
                  }}
                />
              </div>
            </Box>
            <Box p={1} style={{ width: '30%' }}>
              <AddEditServiceForm
                name=""
                serviceId=""
                endDate=""
                actionType={actionTypes.create}
                submitAction={data => this.handleAdd(data)}
              />
            </Box>
          </Box>

          <Box display="flex" px={2} py={1}>
            {referralDetails && referralDetails.isActive ? (
              <AddEditServiceForm
                id={referralDetails.id}
                name={referralDetails.name}
                serviceId={referralDetails.serviceId}
                endDate={referralDetails.endDate}
                actionType={actionTypes.update}
                referralDetails={referralDetails}
                submitAction={data =>
                  this.handleEdit(
                    data,
                    referralDetails.id,
                    referralDetails.isActive,
                    referralDetails.gradeUpgradeAllowed,
                  )
                }
              />
            ) : null}
          </Box>
        </div>
      </DefaultPageWrapper>
    );
  }
}

ReferralServicesForm.propTypes = {
  createReferralService: PropTypes.func.isRequired,
  updateReferralService: PropTypes.func.isRequired,
  dismissError: PropTypes.func.isRequired,
  failureMessage: PropTypes.string.isRequired,
};

export default ReferralServicesForm;
